// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#sidebar-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 250px;
    height: 100vh;
    z-index: 1;
    overflow-y: auto;
    overflow-x: hidden;
    transition: all 0.3s ease;
    padding: 8px;
    border-radius: 0px 16px 16px 0px;
    background-color: var(--md-sys-color-sidebar-background);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .3), 0px 2px 6px 2px rgba(0, 0, 0, .15);
}

nav.fixed-top {
    background-color: var(--md-sys-color-sidebar-background);
}

nav.fixed-top a {
    color: var(--md-sys-color-on-surface-variant)
}

nav.fixed-top .navbar-toggler {
    background-color: var(--md-sys-color-sidebar-background);
    color: var(--md-sys-color-on-surface-variant)
}

nav.fixed-top .navbar-toggler:focus {
    box-shadow: none;
}

#sidebar-wrapper::-webkit-scrollbar {
    width: 5px;
    background-color: #f5f5f5;
}

#sidebar-wrapper::-webkit-scrollbar-thumb {
    background-color: #000000;
}

#sidebar-wrapper .sidebar-heading .rounded-profile-picture {
    width: 90px;
}

.rounded-profile-picture {
    border-radius: 50px;
}

#sidebar-wrapper .list-group-item {
    border: none;
}

#sidebar-wrapper .list-group-item:hover {
    background-color: #c2c2c2;
}

#page-content-wrapper {
    width: 100%;
    margin-left: 230px;
    padding-left: 10px;
    transition: all 0.3s ease;
    background-color: transparent;
}

#wrapper.toggled #sidebar-wrapper {
    width: 80px;
}

#wrapper.toggled #page-content-wrapper {
    padding-left: 80px;
}


#sidebar-wrapper > .list-group > a.list-group-item, #sidebar-wrapper > .list-group > div.list-group-item {
    color: #444746;
    color: var(--md-sys-color-on-surface-variant);
    padding: 2px 16px;
    border-radius: 100px;
    height: 48px;
    display: flex;
    position: relative;
    align-items: center;
    background-color: transparent;
}

#sidebar-wrapper > .list-group > a.list-group-item:hover, #sidebar-wrapper > .list-group > div.list-group-item:hover {
    background-color: #E5E8ED !important;
    color: var(--md-sys-color-shadow-dark);
}

#sidebar-wrapper > .list-group > a.list-group-item:active, #sidebar-wrapper > .list-group > div.list-group-item:active {
    background-color: #c2e7ff !important;
}

#sidebar-wrapper > .list-group > div.list-group-item > a.dropdown-toggle {
    color: #444746;
    text-decoration: none;
}

.dropdown-item:active {
    background-color: #c2e7ff !important;
    color: #444746;
}

.dark-mode-switch-container {
    display: flex;
    position: absolute;
    bottom: 0;
    align-items: center;
    justify-content: center;
    width: 93%;
    height: 80px;
}


.mode-toggle {
    border: none;
    outline: none;
    border-radius: 100%;
    color: var(--md-sys-color-on-surface-variant);
    border: 1px solid var(--md-sys-color-outline);
    background-color: var(--md-sys-color-sidebar-background);;
    font-size: 24px;
    width: 48px;
    height: 48px;
    border-radius: 100px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.nav-projects {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    width: 100%;
    max-width: 1760px;
    margin: 0 auto;
    transition-duration: 300ms;
    transition-property: max-width, margin;
    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
    z-index: 1;
}

.navigation-container {
    display: flex;
    justify-content: center;
    height: 88px;
    margin: 0 8px;
    padding-top: 9px;
    gap: 8px;
    transition: height 300ms cubic-bezier(0.2, 0, 0, 1), opacity 200ms cubic-bezier(0.2, 0, 0, 1);
    border-radius: 0 0 40px 40px;
    opacity: 1;
}

.tabbed-navigation {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    height: 100%;
    border-radius: 40px;
    background: var(--md-sys-color-surface);
    text-align: center;
    white-space: nowrap;
    overflow: auto;
}

.tab {
    display: inline-flex;
    position: relative;
    flex-grow: 1;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
    border: none;
    border-radius: 40px;
    background: var(--md-sys-color-surface);
    color: var(--md-sys-color-on-surface);
    line-height: 44px;
    text-decoration: initial;
    cursor: pointer;
    vertical-align: middle;
}

.tab .material-symbols-sharp {
    margin-right: 8px;
    transition: font-variation-settings 200ms cubic-bezier(0.2, 0, 0, 1);
    font-variation-settings: "wght" 400, "opsz" 24;
    z-index: 1;

}


.tab::before {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    transform: scaleX(0.32);
    transition-duration: 200ms;
    transition-property: transform, opacity;
    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);
    border-radius: 40px;
    background: var(--md-sys-color-tertiary);
    content: "";
}

.tab:hover {
    background: var(--md-sys-color-on-surface-variant);
    color: var(--md-sys-color-on-tertiary);
    text-decoration: none;
}

.tab.active::before {
    opacity: 1;
    transform: scaleX(1);
}

.tab.active > .tab-label, .tab.active > .material-symbols-sharp {
    color: var(--md-sys-color-on-primary);
    font-variation-settings: "GRAD" 125;
    z-index: 5;
}

.tab.active[_ngcontent-djl-c44]:hover::before {
    background: var(--md-sys-color-on-surface-variant);
}

nav.fixed-top {
    display: none;
}

.navbar{
    transition: transform 0.3s ease-in-out;
}

.navbar.navbar-hidden {
    transform: translateY(-100%);
    transition: transform 0.3s ease-in-out;
}

.navbar-toggler {
    border: none;
}

.navbar-toggler.collapsed {
    margin-top: 0;
}

.navbar-toggler .material-symbols-sharp {
    font-size: 30px;
}

.navbar-toggler {
    margin-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/css/navbar.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,yBAAyB;IACzB,YAAY;IACZ,gCAAgC;IAChC,wDAAwD;IACxD,iFAAiF;AACrF;;AAEA;IACI,wDAAwD;AAC5D;;AAEA;IACI;AACJ;;AAEA;IACI,wDAAwD;IACxD;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,6CAA6C;IAC7C,iBAAiB;IACjB,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,6CAA6C;IAC7C,6CAA6C;IAC7C,wDAAwD;IACxD,eAAe;IACf,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,0BAA0B;IAC1B,sCAAsC;IACtC,sDAAsD;IACtD,UAAU;AACd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,QAAQ;IACR,6FAA6F;IAC7F,4BAA4B;IAC5B,UAAU;AACd;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,qCAAqC;IACrC,iBAAiB;IACjB,wBAAwB;IACxB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,oEAAoE;IACpE,8CAA8C;IAC9C,UAAU;;AAEd;;;AAGA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,uBAAuB;IACvB,0BAA0B;IAC1B,uCAAuC;IACvC,sDAAsD;IACtD,mBAAmB;IACnB,wCAAwC;IACxC,WAAW;AACf;;AAEA;IACI,kDAAkD;IAClD,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,UAAU;AACd;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":["#sidebar-wrapper {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 250px;\r\n    height: 100vh;\r\n    z-index: 1;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    transition: all 0.3s ease;\r\n    padding: 8px;\r\n    border-radius: 0px 16px 16px 0px;\r\n    background-color: var(--md-sys-color-sidebar-background);\r\n    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, .3), 0px 2px 6px 2px rgba(0, 0, 0, .15);\r\n}\r\n\r\nnav.fixed-top {\r\n    background-color: var(--md-sys-color-sidebar-background);\r\n}\r\n\r\nnav.fixed-top a {\r\n    color: var(--md-sys-color-on-surface-variant)\r\n}\r\n\r\nnav.fixed-top .navbar-toggler {\r\n    background-color: var(--md-sys-color-sidebar-background);\r\n    color: var(--md-sys-color-on-surface-variant)\r\n}\r\n\r\nnav.fixed-top .navbar-toggler:focus {\r\n    box-shadow: none;\r\n}\r\n\r\n#sidebar-wrapper::-webkit-scrollbar {\r\n    width: 5px;\r\n    background-color: #f5f5f5;\r\n}\r\n\r\n#sidebar-wrapper::-webkit-scrollbar-thumb {\r\n    background-color: #000000;\r\n}\r\n\r\n#sidebar-wrapper .sidebar-heading .rounded-profile-picture {\r\n    width: 90px;\r\n}\r\n\r\n.rounded-profile-picture {\r\n    border-radius: 50px;\r\n}\r\n\r\n#sidebar-wrapper .list-group-item {\r\n    border: none;\r\n}\r\n\r\n#sidebar-wrapper .list-group-item:hover {\r\n    background-color: #c2c2c2;\r\n}\r\n\r\n#page-content-wrapper {\r\n    width: 100%;\r\n    margin-left: 230px;\r\n    padding-left: 10px;\r\n    transition: all 0.3s ease;\r\n    background-color: transparent;\r\n}\r\n\r\n#wrapper.toggled #sidebar-wrapper {\r\n    width: 80px;\r\n}\r\n\r\n#wrapper.toggled #page-content-wrapper {\r\n    padding-left: 80px;\r\n}\r\n\r\n\r\n#sidebar-wrapper > .list-group > a.list-group-item, #sidebar-wrapper > .list-group > div.list-group-item {\r\n    color: #444746;\r\n    color: var(--md-sys-color-on-surface-variant);\r\n    padding: 2px 16px;\r\n    border-radius: 100px;\r\n    height: 48px;\r\n    display: flex;\r\n    position: relative;\r\n    align-items: center;\r\n    background-color: transparent;\r\n}\r\n\r\n#sidebar-wrapper > .list-group > a.list-group-item:hover, #sidebar-wrapper > .list-group > div.list-group-item:hover {\r\n    background-color: #E5E8ED !important;\r\n    color: var(--md-sys-color-shadow-dark);\r\n}\r\n\r\n#sidebar-wrapper > .list-group > a.list-group-item:active, #sidebar-wrapper > .list-group > div.list-group-item:active {\r\n    background-color: #c2e7ff !important;\r\n}\r\n\r\n#sidebar-wrapper > .list-group > div.list-group-item > a.dropdown-toggle {\r\n    color: #444746;\r\n    text-decoration: none;\r\n}\r\n\r\n.dropdown-item:active {\r\n    background-color: #c2e7ff !important;\r\n    color: #444746;\r\n}\r\n\r\n.dark-mode-switch-container {\r\n    display: flex;\r\n    position: absolute;\r\n    bottom: 0;\r\n    align-items: center;\r\n    justify-content: center;\r\n    width: 93%;\r\n    height: 80px;\r\n}\r\n\r\n\r\n.mode-toggle {\r\n    border: none;\r\n    outline: none;\r\n    border-radius: 100%;\r\n    color: var(--md-sys-color-on-surface-variant);\r\n    border: 1px solid var(--md-sys-color-outline);\r\n    background-color: var(--md-sys-color-sidebar-background);;\r\n    font-size: 24px;\r\n    width: 48px;\r\n    height: 48px;\r\n    border-radius: 100px;\r\n    height: 48px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.nav-projects {\r\n    position: -webkit-sticky;\r\n    position: sticky;\r\n    top: 0;\r\n    width: 100%;\r\n    max-width: 1760px;\r\n    margin: 0 auto;\r\n    transition-duration: 300ms;\r\n    transition-property: max-width, margin;\r\n    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);\r\n    z-index: 1;\r\n}\r\n\r\n.navigation-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 88px;\r\n    margin: 0 8px;\r\n    padding-top: 9px;\r\n    gap: 8px;\r\n    transition: height 300ms cubic-bezier(0.2, 0, 0, 1), opacity 200ms cubic-bezier(0.2, 0, 0, 1);\r\n    border-radius: 0 0 40px 40px;\r\n    opacity: 1;\r\n}\r\n\r\n.tabbed-navigation {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    height: 100%;\r\n    border-radius: 40px;\r\n    background: var(--md-sys-color-surface);\r\n    text-align: center;\r\n    white-space: nowrap;\r\n    overflow: auto;\r\n}\r\n\r\n.tab {\r\n    display: inline-flex;\r\n    position: relative;\r\n    flex-grow: 1;\r\n    align-items: center;\r\n    justify-content: center;\r\n    padding: 0 24px;\r\n    border: none;\r\n    border-radius: 40px;\r\n    background: var(--md-sys-color-surface);\r\n    color: var(--md-sys-color-on-surface);\r\n    line-height: 44px;\r\n    text-decoration: initial;\r\n    cursor: pointer;\r\n    vertical-align: middle;\r\n}\r\n\r\n.tab .material-symbols-sharp {\r\n    margin-right: 8px;\r\n    transition: font-variation-settings 200ms cubic-bezier(0.2, 0, 0, 1);\r\n    font-variation-settings: \"wght\" 400, \"opsz\" 24;\r\n    z-index: 1;\r\n\r\n}\r\n\r\n\r\n.tab::before {\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 100%;\r\n    opacity: 0;\r\n    transform: scaleX(0.32);\r\n    transition-duration: 200ms;\r\n    transition-property: transform, opacity;\r\n    transition-timing-function: cubic-bezier(0.2, 0, 0, 1);\r\n    border-radius: 40px;\r\n    background: var(--md-sys-color-tertiary);\r\n    content: \"\";\r\n}\r\n\r\n.tab:hover {\r\n    background: var(--md-sys-color-on-surface-variant);\r\n    color: var(--md-sys-color-on-tertiary);\r\n    text-decoration: none;\r\n}\r\n\r\n.tab.active::before {\r\n    opacity: 1;\r\n    transform: scaleX(1);\r\n}\r\n\r\n.tab.active > .tab-label, .tab.active > .material-symbols-sharp {\r\n    color: var(--md-sys-color-on-primary);\r\n    font-variation-settings: \"GRAD\" 125;\r\n    z-index: 5;\r\n}\r\n\r\n.tab.active[_ngcontent-djl-c44]:hover::before {\r\n    background: var(--md-sys-color-on-surface-variant);\r\n}\r\n\r\nnav.fixed-top {\r\n    display: none;\r\n}\r\n\r\n.navbar{\r\n    transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.navbar.navbar-hidden {\r\n    transform: translateY(-100%);\r\n    transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.navbar-toggler {\r\n    border: none;\r\n}\r\n\r\n.navbar-toggler.collapsed {\r\n    margin-top: 0;\r\n}\r\n\r\n.navbar-toggler .material-symbols-sharp {\r\n    font-size: 30px;\r\n}\r\n\r\n.navbar-toggler {\r\n    margin-top: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
